import React, { useState, useEffect, useRef } from "react";
import utils from "../../utils";

import { useMachine } from "../../contexts/MachineContext";
import CheckboxButton from "../buttons/ButtonCheckbox";

export default function MachineSettings({
	name,
	alphabet,
	states,
	initialStateID,
	acceptStatesIDs,
	show,
}) {
	const { autoAlphabet, setAutoAlphabet, updateAlphabet, renameMachine } =
		useMachine();
	const alphabetInputRef = useRef();
	const nameInputRef = useRef();

	useEffect(() => {
		alphabetInputRef.current.value = alphabet
			? alphabet.toString()
			: "Vacío";
	}, [alphabet]);

	useEffect(() => {
		nameInputRef.current.value = name;
	}, [name]);

	function ChangeAutoAlphabet() {
		setAutoAlphabet(!autoAlphabet);
	}
	function UpdateAlphabet() {
		updateAlphabet(alphabetInputRef.current.value);
	}
	function UpdateName() {
		renameMachine(nameInputRef.current.value);
	}

	return (
		<div className={`editor-panel machine-settings ${show ? "open" : ""}`}>
			<input
				type="text"
				className="panel-title input"
				ref={nameInputRef}
				onChange={UpdateName}
				defaultValue={name}
			/>
			<div className="setting">
				<p className="setting-title">Estados</p>
				<p className="setting-detail">
					{"{"}
					{states.map((state, index) => {
						if (index < states.length - 1) {
							return state.name + ", ";
						} else {
							return state.name;
						}
					})}
					{"}"}
				</p>
			</div>
			<div className="setting">
				<p className="setting-title">Estado inicial</p>
				<p className="setting-detail">
					{states[utils.IDToIndex(states, initialStateID)].name}
				</p>
			</div>
			<div className="setting">
				<p className="setting-title">Estados finales</p>
				<p className="setting-detail">
					{"{"}
					{acceptStatesIDs.map((id, index) => {
						if (index < acceptStatesIDs.length - 1) {
							return (
								states[utils.IDToIndex(states, id)].name + ", "
							);
						} else {
							return states[utils.IDToIndex(states, id)].name;
						}
					})}
					{"}"}
				</p>
			</div>
			<div className="setting alphabet">
				<p className="setting-title">Alfabeto</p>
				<input
					type="text"
					className="setting-input"
					ref={alphabetInputRef}
					defaultValue={alphabet ? alphabet.toString() : "Vacío"}
				/>
				<div className="setting-actions">
					<CheckboxButton
						value={autoAlphabet}
						handleClick={ChangeAutoAlphabet}
						text="Automático"
					/>
					<button className="action-button" onClick={UpdateAlphabet}>
						Actualizar
					</button>
				</div>
			</div>
		</div>
	);
}
